import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostListener,
    Input,
    NgZone,
    OnInit,
    TemplateRef,
    ViewChild
} from '@angular/core';
import {Router} from "@angular/router";
import feather from 'feather-icons';
import {ProductsComponent} from "../products.component";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {Product} from "app/models/Product"
import * as snippet from 'app/main/pages/gestionProduits/modals.snippetcode';
import {ToastrService} from "ngx-toastr";
import {ProductsService} from "../../../../services/products/products.service";
import {PaginatedResponse} from "../../../../models/paginatedResponse";
import {Taxe, TaxeService} from "../../../parametre/taxe-tva/parametre-taxe/taxe.service";
import {Fournisseur} from "../../../../models/fournisseur";
import {CategorieService} from "../../../../services/categorie-unite-marque/categorie.service";
import {Categorie} from "../../../../models/categorie";
import {Marque} from "../../../../models/marque";
import {MarqueService} from "../../../../services/categorie-unite-marque/marque.service";
import {Tva, TvaService} from "../../../parametre/taxe-tva/parametre-tva/tva.service";
import {forkJoin, of, Subscription} from "rxjs";
import {catchError, finalize, map} from "rxjs/operators";
import {StockService} from "../../../../services/stock/stock.service";

export type ProductTableViewRow =
    | { kind: 'simple'; product: Product }
    | { kind: 'group'; refFab: string; primary: Product; siblings: Product[] };

@Component({
    selector: 'app-product-table',
    templateUrl: './product-table.component.html',
    styleUrls: ['./product-table.component.scss']
})
export class ProductTableComponent implements OnInit {
    isLoading: boolean = false;
    currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');

    clientId = this.currentUser?.id;
    stationId =
        this.currentUser?.stations?.[0]?.station_id ??
        this.currentUser?.stations?.[0]?.id ??
        this.currentUser?.station_id ??
        0;

    @Input() isArchive: boolean = false;
    searchTerm: string = '';
    products: any[] = [];
    filteredProducts: any[] = [];
    tableViewRows: ProductTableViewRow[] = [];
    private expandedRefFabKeys: Set<string> = new Set();
    constructor(private router : Router, public parent: ProductsComponent,
                private ngZone: NgZone, private modalService: NgbModal,
                private toastr: ToastrService,  private categorieService: CategorieService,
                private productsService : ProductsService,  private tvaService: TvaService,
                private cdr: ChangeDetectorRef,   private marqueService: MarqueService,  private taxeService: TaxeService,
                private stockService: StockService
    ) { }


    public _snippetCodeModalThemes = snippet.snippetCodeModalThemes;
    public _snippetCodeBasicModal = snippet.snippetCodeBasicModal;
    categories: Categorie[] = [];
    brands : Marque[] = [];
    taxes: Taxe[] = [];
    tva: Tva[] = [];

    selectedProduct: Product | null = null;
    /** Ligne groupe (famille ref. fabricant) : tous les produits à archiver sur confirmation. */
    productsToArchive: Product[] = [];

    filterSummary: string = '';
    showFilter = false;
    filters = {
        type: '',
        categories_id: '',
        brand: '',
        priceOperator: '=',
        price: null,
        tva_id: '',
        tax_id: '',
        // barcode: '',
        stockStatus: '',
        dateFrom: '',
        dateTo: ''
    };
    searchText = '';
    currentPage = 1;
    perPage = 10;
    pageOptions = [ 10, 25, 50, 100];

    totalItems: number = 0;
    paginatedData: Product[] = [];
    pages: number[] = [];
    basicSelectedOption: number = 10;
    
    // Cache pour stocker les quantités de stock par produit
    private stockQuantitiesCache: Map<number, number> = new Map();
    
    get totalPages(): number {
        return Math.ceil(this.totalItems / this.perPage) || 1;
    }
    @ViewChild('filterPanel') filterPanel?: ElementRef<HTMLElement>;

    toggleFilter(ev?: MouseEvent): void {
        ev?.stopPropagation();
        this.showFilter = !this.showFilter;
        this.cdr.markForCheck();
        if (this.showFilter) {
            setTimeout(() => {
                try {
                    feather.replace();
                } catch {
                    /* ignore */
                }
            }, 0);
        }
    }

    @HostListener('document:click', ['$event'])
    onClickOutside(event: MouseEvent) {
        if (!this.showFilter) {
            return;
        }
        const target = event.target;
        if (!(target instanceof Node)) {
            return;
        }
        const el = target instanceof Element ? target : target.parentElement;
        if (el?.closest?.('.product-table__filter-toggle')) {
            return;
        }
        const panel = this.filterPanel?.nativeElement;
        if (panel?.contains(target)) {
            return;
        }
        this.showFilter = false;
        this.cdr.markForCheck();
    }

    loadCategories(): void {
        if (this.clientId && this.stationId) {
            // this.isLoading = true;
            this.categorieService.getAll(this.stationId, this.clientId).subscribe({
                next: (categories) => {
                    this.categories = [...categories];
                    this.isLoading = false;
                    if (categories.length === 0) {
                        // this.toastr.info('Aucune catégorie trouvée pour cette station.', 'Information');
                    }
                    this.cdr.detectChanges();
                },
                error: (error) => {
                    this.isLoading = false;
                    this.toastr.error(error.message || 'Erreur lors du chargement des catégories.', 'Erreur');
                }
            });
        } else {
            this.toastr.error('Informations utilisateur ou station manquantes.', 'Erreur');
        }
    }

    loadMarques(): void {
        if (this.clientId && this.stationId) {
            //this.isLoading = true;
            this.marqueService.getAll(this.stationId, this.clientId).subscribe({
                next: (marques) => {
                    this.brands = [...marques];
                    this.isLoading = false;
                    if (marques.length === 0) {
                        // this.toastr.info('Aucune marque trouvée pour cette station.', 'Information');
                    }
                    this.cdr.detectChanges();
                },
                error: (error) => {
                    this.isLoading = false;
                    this.toastr.error(error.message || 'Erreur lors du chargement des marques.', 'Erreur');
                }
            });
        } else {
            this.toastr.error('Informations utilisateur ou station manquantes.', 'Erreur');
        }
    }


    loadTaxe(): void {
        // this.isLoading = true;
        this.taxeService.getTaxeList(this.stationId).subscribe({
            next: (data: any) => {
                this.taxes = (data.taxes || []).filter((t: any) => t.statut === true);
                this.isLoading = false;
                this.cdr.detectChanges();
            },
            error: (err) => {
                this.toastr.error('Erreur lors du chargement des taxes');
                this.isLoading = false;
                this.cdr.detectChanges();
            }
        });
    }

    loadTVA(): void {
        //this.isLoading = true;
        this.tvaService.getTvaList(this.stationId).subscribe({
            next: (data: any) => {
                this.tva = (data.tvaListe || []).filter((t: any) => t.statut === true);
                //   console.log("TVA actives :", this.tva);
                this.isLoading = false;
                this.cdr.detectChanges();
            },
            error: (err) => {
                this.toastr.error('Erreur lors du chargement des TVA');
                this.isLoading = false;
                this.cdr.detectChanges();
            }
        });
    }

    updatePagination() {
        // Ensure currentPage doesn't exceed totalPages
        const calculatedTotalPages = Math.ceil(this.totalItems / this.perPage) || 1;
        if (this.currentPage > calculatedTotalPages) {
            this.currentPage = calculatedTotalPages;
        }
        this.pages = Array.from({ length: calculatedTotalPages }, (_, i) => i + 1);
        this.paginatedData = this.filteredProducts;
    }

    changePage(page: number) {
        if (page >= 1 && page <= this.totalPages && page !== this.currentPage && !this.isLoading) {
            this.currentPage = page;
            // No need to reload products, ngx-pagination handles pagination of filteredProducts
        }
    }

    openArchiveModal(content: TemplateRef<any>, product: Product) {
        this.selectedProduct = product;
        this.productsToArchive = [];
        this.modalService.open(content, { centered: true });
    }

    /**
     * Ligne famille (chevron) : archiver tous les produits ayant la même référence fabricant (primaire + variantes).
     */
    tryOpenArchiveRefFabGroup(content: TemplateRef<any>, row: ProductTableViewRow): void {
        if (row.kind !== 'group') {
            return;
        }
        const all: Product[] = [row.primary, ...row.siblings];
        const pending = all.filter((p) => p.id != null && !p.is_archive);
        if (pending.length === 0) {
            this.toastr.info('Tous les produits de cette famille sont déjà archivés.', '', {
                positionClass: 'toast-bottom-right',
                toastClass: 'toast ngx-toastr'
            });
            return;
        }
        this.productsToArchive = pending;
        this.selectedProduct = row.primary;
        this.modalService.open(content, { centered: true });
    }

    /** Icône corbeille toujours visible : n’ouvre le modal d’archivage que si le produit ne l’est pas déjà. */
    tryOpenArchiveModal(content: TemplateRef<any>, product: Product) {
        if (product.is_archive) {
            this.toastr.info('Ce produit est déjà archivé.', '', {
                positionClass: 'toast-bottom-right',
                toastClass: 'toast ngx-toastr',
            });
            return;
        }
        this.openArchiveModal(content, product);
    }


    ngOnInit(): void {
        // this.loadProducts();
        this.loadAllProducts();
        this.resetFilters();
        this.loadCategories();
        this.loadMarques();
        this.loadTaxe();
        this.loadTVA();

    }

    onClick() {
        this.router.navigate(['/produits-services/ajout-produit']);
    }
    /*  archiveProduct(modal: NgbModalRef) {
        if (this.selectedProduct) {
          this.selectedProduct.is_archive = false;
          this.toastr.success('Produit archivé !', '', {
            positionClass: 'toast-bottom-right',
            toastClass: 'toast ngx-toastr custom-success-toast',
          });
          this.selectedProduct = null;
          modal.close();
        }
      }*/

    archiveProduct(modal: NgbModalRef): void {
        const resetModalState = () => {
            this.selectedProduct = null;
            this.productsToArchive = [];
        };

        if (this.productsToArchive.length > 0) {
            const list = [...this.productsToArchive];
            forkJoin(
                list.map((p) =>
                    this.productsService.archiverProduct(p.id as number).pipe(
                        catchError(() => of({ __archiveError: true, id: p.id }))
                    )
                )
            )
                .pipe(finalize(() => resetModalState()))
                .subscribe({
                    next: (results: any[]) => {
                        const failed = results.filter((r) => r && r.__archiveError);
                        const ok = results.length - failed.length;
                        if (failed.length > 0 && ok === 0) {
                            this.toastr.error(
                                "Erreur lors de l'archivage des produits.",
                                '',
                                {
                                    positionClass: 'toast-bottom-right',
                                    toastClass: 'toast ngx-toastr custom-error-toast'
                                }
                            );
                        } else if (failed.length > 0) {
                            this.toastr.warning(
                                `${ok} produit(s) archivé(s), ${failed.length} erreur(s).`,
                                '',
                                {
                                    positionClass: 'toast-bottom-right',
                                    toastClass: 'toast ngx-toastr'
                                }
                            );
                        } else {
                            this.toastr.success(
                                `${ok} produit(s) archivé(s) !`,
                                '',
                                {
                                    positionClass: 'toast-bottom-right',
                                    toastClass: 'toast ngx-toastr custom-success-toast'
                                }
                            );
                        }
                        this.loadAllProducts();
                        modal.close();
                    },
                    error: () => {
                        this.toastr.error("Erreur lors de l'archivage.", '', {
                            positionClass: 'toast-bottom-right',
                            toastClass: 'toast ngx-toastr custom-error-toast'
                        });
                        modal.close();
                    }
                });
            return;
        }

        if (this.selectedProduct) {
            this.productsService.archiverProduct(this.selectedProduct.id).subscribe({
                next: () => {
                    this.selectedProduct!.is_archive = true;
                    this.toastr.success('Produit archivé !', '', {
                        positionClass: 'toast-bottom-right',
                        toastClass: 'toast ngx-toastr custom-success-toast'
                    });
                    this.loadAllProducts();
                    resetModalState();
                    modal.close();
                },
                error: () => {
                    this.toastr.error("Erreur lors de l'archivage du produit", '', {
                        positionClass: 'toast-bottom-right',
                        toastClass: 'toast ngx-toastr custom-error-toast'
                    });
                }
            });
        }
    }

    detail(productId: number) {
        this.ngZone.run(() => {
            this.router.navigate(['/bibliotheque-test/detail-produit', productId]);
        });
    }

    goToEdit(productId: string) {
        this.router.navigate(['/bibliotheque-test/modifier-produit', productId], {
            queryParams: { step: 1 }
        });
    }

    duplicateProduct(product: Product, event?: Event): void {
        event?.stopPropagation();
        const productId = product?.id != null ? Number(product.id) : NaN;
        if (!Number.isFinite(productId) || productId <= 0) {
            this.toastr.error('ID produit manquant pour la duplication.', 'Erreur');
            return;
        }
        this.router.navigate(['/bibliotheque-test/ajout-produit'], {
            state: {
                isDuplicateMode: true,
                sourceProductId: productId,
                isDuplicateFamily: false,
                familyProductIds: []
            }
        });
    }

    duplicateRefFabGroup(row: ProductTableViewRow, event?: Event): void {
        event?.stopPropagation();
        if (row.kind !== 'group') {
            return;
        }
        const primaryId = row.primary?.id != null ? Number(row.primary.id) : NaN;
        if (!Number.isFinite(primaryId) || primaryId <= 0) {
            this.toastr.error('ID produit manquant pour la duplication.', 'Erreur');
            return;
        }
        const familyProductIds = [row.primary, ...row.siblings]
            .map((p) => (p?.id != null ? Number(p.id) : NaN))
            .filter((id) => Number.isFinite(id) && id > 0);
        this.router.navigate(['/bibliotheque-test/ajout-produit'], {
            state: {
                isDuplicateMode: true,
                sourceProductId: primaryId,
                isDuplicateFamily: true,
                familyProductIds
            }
        });
    }


    // Refactored Component Method
    loadAllProducts(page: number = 1, limit: number = 1000): void {
        // 1. Reset state only once
        this.products = [];
        this.filteredProducts = [];
        this.tableViewRows = [];
        this.expandedRefFabKeys.clear();
        // Vider le cache des quantités de stock
        this.stockQuantitiesCache.clear();
        if (this.isLoading) {
            return;
        }
        this.isLoading = true;
        let accumulatedProducts: Product[] = []; // Temporary array to hold ALL fetched data
        let currentPage = 1;

        const fetchPage = () => {
            if (!this.stationId) {
                this.isLoading = false;
                this.toastr.error('Station introuvable (utilisateur). Impossible de charger les produits.', 'Erreur');
                this.filteredProducts = [];
                this.products = [];
                this.tableViewRows = [];
                this.totalItems = 0;
                this.updatePagination();
                return;
            }
            this.productsService.getProductsByStationId(this.stationId, currentPage, limit, this.isArchive).subscribe({
                next: (response: PaginatedResponse<Product>) => {
                    const raw = response as any;
                    const pageRows: Product[] = Array.isArray(raw?.data)
                        ? raw.data
                        : Array.isArray(raw?.products)
                            ? raw.products
                            : [];

                    if (pageRows.length > 0) {
                        accumulatedProducts.push(...pageRows);
                        currentPage++;

                        const totalPages =
                            raw.meta?.pages ??
                            raw.meta?.nb_total_pages ??
                            Math.max(
                                1,
                                Math.ceil(
                                    (raw.meta?.total ?? accumulatedProducts.length) / limit
                                )
                            );
                        if (currentPage <= totalPages) {
                            fetchPage();
                        } else {
                            this.products = accumulatedProducts;
                            this.totalItems = (raw.meta?.total ?? accumulatedProducts.length) || 0;
                            this.filteredProducts = [...this.products];
                            this.updateFilteredData();
                            this.isLoading = false;

                            this.loadStockQuantitiesForAllProducts();
                        }
                    } else {
                        this.products = accumulatedProducts;
                        this.totalItems = accumulatedProducts.length || 0;
                        this.filteredProducts = [...this.products];
                        this.updateFilteredData();
                        this.isLoading = false;

                        this.loadStockQuantitiesForAllProducts();
                    }
                },
                error: (err) => {
                    this.isLoading = false;
                    this.toastr.error('Erreur lors du chargement des produits');
                    this.filteredProducts = [];
                    this.products = [];
                    this.tableViewRows = [];
                    this.totalItems = 0;
                    this.updatePagination();
                }
            });
        };

        fetchPage();
    }

    onSearch() {
        this.currentPage = 1;
        this.applyFilters();
    }

    clearFilter() {
        this.resetFilters();
        this.filterSummary = '';
        this.searchTerm = '';

        this.currentPage = 1;
        this.loadAllProducts();
    }

    resetFilters() {
        this.filters = {
            type: '',
            categories_id: '',
            brand: '',
            priceOperator: '=',
            price: null,
            tva_id: '',
            tax_id: '',
            // barcode: '',
            stockStatus: '',
            dateFrom: '',
            dateTo: ''
        };
        this.searchTerm = '';
        this.currentPage = 1;
        //  this.loadAllProducts();
    }
    onFilterChange() {
        // Debounce this function if needed for performance
        this.currentPage = 1;
        this.updateFilterSummary();
    }
    onLimitChange() {
        this.currentPage = 1;
        this.basicSelectedOption = this.perPage;
        this.updatePagination();
    }
    applyFilters() {
        this.currentPage = 1;
        this.updateFilterSummary();
        this.showFilter = false;
        // Filtres = client-side sur la liste déjà chargée par loadAllProducts (pas de reload : évite tableau vide + race isLoading).
        this.updateFilteredData();
    }

    updateFilterSummary() {
        const activeFilters: string[] = [];

        if (this.filters.type) activeFilters.push(`Type: ${this.filters.type}`);

        if (this.filters.categories_id) {
            const cat = this.categories.find(c => c.id === Number(this.filters.categories_id));
            if (cat) activeFilters.push(`Catégorie: ${cat.libelle}`);
        }

        if (this.filters.brand) {
            const brand = this.brands.find(b => b.id === Number(this.filters.brand));
            if (brand) activeFilters.push(`Marque: ${brand.libelle}`);
        }

        if (this.filters.price != null)
            activeFilters.push(`Prix: ${this.filters.priceOperator} ${this.filters.price}`);

        if (this.filters.tva_id) {
            const tvaItem = this.tva.find(t => t.id === Number(this.filters.tva_id));
            if (tvaItem) activeFilters.push(`TVA: ${tvaItem.valeur}%`);
        }

        if (this.filters.tax_id) {
            const taxItem = this.taxes.find(t => t.id === Number(this.filters.tax_id));
            if (taxItem) activeFilters.push(`Taxe: ${taxItem.nom}`);
        }

        if (this.filters.stockStatus)
            activeFilters.push(`Stock: ${this.filters.stockStatus === 'in' ? 'En stock' : 'Rupture'}`);

        if (this.filters.dateFrom || this.filters.dateTo)
            activeFilters.push(`Date: ${this.filters.dateFrom || '...'} → ${this.filters.dateTo || '...'}`);

        this.filterSummary = activeFilters.join(', ');
    }

    /** Code-barres considéré comme « parent » (0 ou vide) pour choisir la ligne principale du groupe. */
    private isBarcodeEmptyOrZero(p: any): boolean {
        const c = p?.code_barre;
        if (c == null || c === '') {
            return true;
        }
        const s = String(c).trim();
        if (s === '' || s === '0') {
            return true;
        }
        const n = Number(s.replace(',', '.'));
        return !Number.isNaN(n) && n === 0;
    }

    /** Produit principal du groupe : priorité à code_barre vide / 0. */
    private pickPrimaryInRefFabGroup(group: Product[]): Product {
        const zeros = group.filter(p => this.isBarcodeEmptyOrZero(p));
        if (zeros.length > 0) {
            return zeros[0];
        }
        return group[0];
    }

    private normalizeRefFabricant(raw: any): string {
        if (raw == null) {
            return '';
        }
        const s = String(raw).trim();
        return s;
    }

    /**
     * Sans ref. fabricant : une ligne par produit (comportement historique).
     * Avec ref. fabricant : une ligne par valeur distincte, primaire = code-barres 0/vide ; variantes sous chevron.
     */
    private buildTableViewRows(products: Product[]): ProductTableViewRow[] {
        const simple: Product[] = [];
        const byRef = new Map<string, Product[]>();
        for (const p of products) {
            const ref = this.normalizeRefFabricant((p as any).ref_fabricant ?? (p as any).ref_fabriquant);
            if (!ref) {
                simple.push(p);
            } else {
                if (!byRef.has(ref)) {
                    byRef.set(ref, []);
                }
                byRef.get(ref)!.push(p);
            }
        }
        const rows: ProductTableViewRow[] = [];
        const keys = Array.from(byRef.keys()).sort((a, b) => a.localeCompare(b, 'fr', { sensitivity: 'base' }));
        for (const refFab of keys) {
            const group = byRef.get(refFab)!;
            const primary = this.pickPrimaryInRefFabGroup(group);
            const siblings = group.filter(x => x.id !== primary.id);
            rows.push({ kind: 'group', refFab, primary, siblings });
        }
        for (const p of simple) {
            rows.push({ kind: 'simple', product: p });
        }
        return rows;
    }

    isRefFabExpanded(refFab: string): boolean {
        return this.expandedRefFabKeys.has(refFab);
    }

    toggleRefFabGroup(refFab: string, event?: Event): void {
        event?.stopPropagation();
        if (this.expandedRefFabKeys.has(refFab)) {
            this.expandedRefFabKeys.delete(refFab);
        } else {
            this.expandedRefFabKeys.add(refFab);
        }
        this.cdr.markForCheck();
    }

    updateFilteredData() {
        const searchTermLower = (this.searchTerm || '').toLowerCase();

        this.filteredProducts = this.products.filter(product => {
            const filterCategoryId = this.filters.categories_id ? Number(this.filters.categories_id) : null;
            const filterBrandId = this.filters.brand ? Number(this.filters.brand) : null;
            const filterTvaId = this.filters.tva_id ? Number(this.filters.tva_id) : null;
            const filterTaxId = this.filters.tax_id ? Number(this.filters.tax_id) : null;

            const categoryName = this.getCategoryName(product.categories_id).toLowerCase();
            const brandName = this.getBrandName(product.marque_id).toLowerCase();

            const codeBarreStr = (product as any).code_barre != null ? String((product as any).code_barre) : '';
            const searchMatch =
                (product.nom || '').toLowerCase().includes(searchTermLower) ||
                (product.description || '').toLowerCase().includes(searchTermLower) ||
                (product.ref_interne || '').toLowerCase().includes(searchTermLower) ||
                (product.ref_fabricant || (product as any).ref_fabriquant || '')
                    .toLowerCase()
                    .includes(searchTermLower) ||
                codeBarreStr.toLowerCase().includes(searchTermLower) ||
                categoryName.includes(searchTermLower) ||
                brandName.includes(searchTermLower);

            const typeMatch = !this.filters.type || product.type === this.filters.type;
            const categoryMatch = !filterCategoryId || product.categories_id === filterCategoryId;
            const brandMatch = !filterBrandId || product.marque_id === filterBrandId;

            let priceMatch = true;
            if (this.filters.price != null) {
                const price = product.prix_unitaires || 0;
                switch (this.filters.priceOperator) {
                    case '=': priceMatch = price == this.filters.price; break;
                    case '>': priceMatch = price > this.filters.price; break;
                    case '<': priceMatch = price < this.filters.price; break;
                }
            }

            const tvaMatch = !filterTvaId || product.tva_id === filterTvaId;
            const taxMatch = !filterTaxId || product.taxe_id === filterTaxId;

            // Utiliser la quantité de stock depuis l'API au lieu de informations_logistique
            const stock = this.getStockQuantity(product.id);
            const stockMatch = !this.filters.stockStatus ||
                (this.filters.stockStatus === 'in' && stock > 0) ||
                (this.filters.stockStatus === 'out' && stock <= 0);

            let dateMatch = true;
            if (this.filters.dateFrom || this.filters.dateTo) {
                const productDate = new Date(product.created_at); // use your real field
                if (isNaN(productDate.getTime())) return false; // invalid date

                const from = this.filters.dateFrom ? new Date(this.filters.dateFrom + 'T00:00:00') : null;
                const to = this.filters.dateTo ? new Date(this.filters.dateTo + 'T23:59:59') : null;

                if (from && productDate < from) dateMatch = false;
                if (to && productDate > to) dateMatch = false;
            }

            return searchMatch && typeMatch && categoryMatch && brandMatch &&
                priceMatch && tvaMatch && taxMatch && stockMatch && dateMatch;
        });

        this.tableViewRows = this.buildTableViewRows(this.filteredProducts);
        // Pagination sur les lignes « top » (simple + groupes), pas sur chaque variante.
        this.totalItems = this.tableViewRows.length;
        this.updatePagination();
    }


    getCategoryName(id: number): string {
        const category = this.categories.find(c => c.id === id); // Assurez-vous que c.id est correct

        return category ? category.libelle : '';

    }
    getBrandName(id: number): string {
        const brand = this.brands.find(b => b.id === id); // Assurez-vous que b.id est correct
        return brand ? brand.libelle : '';
    }

    getTaxesNames(item: any): string {
        if (!item.taxes || !Array.isArray(item.taxes) || item.taxes.length === 0) {
            return '--';
        }
        return item.taxes
            .map((taxe: any) => taxe.nom)
            .filter((nom: string) => nom) // Filter out null/undefined/empty names
            .join(', ');
    }

    /** Clé stable pour le cache stock (les id API sont parfois des chaînes). */
    private normalizeProductIdForStock(id: unknown): number | null {
        if (id == null || id === '') {
            return null;
        }
        const n = typeof id === 'number' ? id : parseInt(String(id), 10);
        return Number.isFinite(n) && n > 0 ? n : null;
    }

    /**
     * Quantités : POST /api/stock/totals-by-erp-products (batch).
     */
    private loadStockQuantitiesForAllProducts(): void {
        if (!this.products || this.products.length === 0) {
            return;
        }

        const productsToLoad = this.products.filter((p) => this.normalizeProductIdForStock(p.id) != null);
        if (productsToLoad.length === 0) {
            return;
        }

        for (const p of this.products) {
            const key = this.normalizeProductIdForStock(p.id);
            if (key == null) {
                continue;
            }
            const raw =
                (p as any).quantity ??
                (p as any).total_quantity ??
                (p as any).stock_quantity ??
                (p as any)?.stock?.quantity;
            if (raw == null || raw === '') {
                continue;
            }
            const q = Number(raw);
            if (Number.isFinite(q) && q >= 0) {
                this.stockQuantitiesCache.set(key, q);
            }
        }
        this.updateFilteredData();
        this.cdr.detectChanges();

        const pids = productsToLoad.map((product) => this.normalizeProductIdForStock(product.id)!);
        console.log(
            `[ProductTable][stock] POST /api/stock/totals-by-erp-products pour ${pids.length} produit(s)`
        );

        this.stockService.getTotalStockByErpProductIds(pids).pipe(
            catchError((err) => {
                console.error('[loadStockQuantitiesForAllProducts] batch', err);
                const empty: Record<number, number> = {};
                for (const pid of pids) {
                    empty[pid] = 0;
                }
                return of(empty);
            })
        ).subscribe({
            next: (totals) => {
                for (const pid of pids) {
                    const n = Number(totals[pid]);
                    this.stockQuantitiesCache.set(pid, Number.isFinite(n) ? n : 0);
                }
                console.log(`✅ [loadStockQuantitiesForAllProducts] ${pids.length} quantité(s) en cache (batch)`);
                this.updateFilteredData();
                this.cdr.detectChanges();
            },
            error: (err) => {
                console.error('[loadStockQuantitiesForAllProducts] batch', err);
                this.cdr.detectChanges();
            }
        });
    }

    getStockQuantity(productId: number | null | undefined): number {
        const key = this.normalizeProductIdForStock(productId);
        if (key == null) {
            return 0;
        }
        const cachedQty = this.stockQuantitiesCache.get(key);
        if (cachedQty !== undefined) {
            return cachedQty;
        }
        return 0;
    }

    /**
     * Ligne groupe (ref. fabricant) : somme des quantités stock du primaire + toutes les variantes.
     */
    getRefFabGroupTotalStockQuantity(row: ProductTableViewRow): number {
        if (row.kind !== 'group') {
            return 0;
        }
        let sum = this.getStockQuantity(row.primary.id);
        for (const s of row.siblings) {
            sum += this.getStockQuantity(s.id);
        }
        return sum;
    }

    /** Statut agrégé pour la ligne groupe : en stock si la somme > 0. */
    getRefFabGroupStockStatus(row: ProductTableViewRow): string {
        return this.getRefFabGroupTotalStockQuantity(row) > 0 ? 'En stock' : 'En rupture';
    }

    /**
     * Obtenir le statut de stock pour un produit
     */
    getStockStatus(productId: number | null | undefined): string {
        const quantity = this.getStockQuantity(productId);
        return quantity > 0 ? 'En stock' : 'En rupture';
    }

    /**
     * Colonne « Référence » : ref. fabricant en priorité, repli sur réf. interne.
     */
    displayRefColumn(p: Product | any): string {
        const fabRaw = p?.ref_fabricant ?? (p as any)?.ref_fabriquant;
        const fab = fabRaw != null ? String(fabRaw).trim() : '';
        if (fab !== '') {
            return fab;
        }
        const internal = p?.ref_interne != null ? String(p.ref_interne).trim() : '';
        return internal !== '' ? internal : '—';
    }

    /**
     * Affichage dans la 1re colonne pour les lignes variantes (sous le chevron) : code-barres, pas la réf. interne.
     */
    displayCodeBarre(p: Product | any): string {
        const c = p?.code_barre;
        if (c == null || c === '') {
            return '--';
        }
        const s = String(c).trim();
        return s === '' ? '--' : s;
    }

    /** Ligne sous désignation : couleur / taille ; « -- » si l’une des deux est vide (ligne masquée si les deux absentes). */
    formatCouleurTailleLine(p: Product | any): string {
        const c = p?.couleur != null ? String(p.couleur).trim() : '';
        const t = p?.taille != null ? String(p.taille).trim() : '';
        if (!c && !t) {
            return '';
        }
        const cDisp = c || '--';
        const tDisp = t || '--';
        return `${cDisp} / ${tDisp}`;
    }

    /** Affiche « famille / sous_famille » ou une seule valeur ; tiret si vide. */
    formatFamilleSousFamilleLine(p: Product | any): string {
        const f = p?.famille != null ? String(p.famille).trim() : '';
        const sf = p?.sous_famille != null ? String(p.sous_famille).trim() : '';
        if (f && sf) {
            return `${f} / ${sf}`;
        }
        if (f || sf) {
            return f || sf;
        }
        return '—';
    }

}
